<template>
<div>
  <div class="d-flex" id="wrapper">
    <!-- Sidebar -->
    <SideBar />
    <!-- /#sidebar-wrapper -->
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
        <div>
          <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
          </button>

          <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
          </button>
        </div>
        <div class="d-flex">
          <!-- <i class="fas fa-home text-muted hover-cursor" @click="toPage('/dashboard')"></i> -->
            <p class="text-muted mb-0 hover-cursor">&nbsp;Insurance /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Vendors</p>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
            <li class="nav-item dropdown">
              <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ admin }}
              </a>
              <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 grid-margin stretch-card card-div">
            <div class="container">
              <div class="row">
                    <div class="col-3">
                        <button class="btn btn-primary btn-sm" style=" border-radius: 10px; width : 100%;" @click="toRegisterVendorPage(false, null)">
                            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 28 28" fill="none">
                                <circle cx="14" cy="14" r="10.5" fill="white"/>
                                <path d="M14 9.33331L14 18.6666" stroke="#247FEC" stroke-width="2" stroke-linecap="round"/>
                                <path d="M18.6665 14L9.33317 14" stroke="#247FEC" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                            Tambah Vendor Baru
                        </button>
                    </div>
                     <div class="col-7">
                        <!-- <input type="text" style="width : 100%;" class="form-control" id="searchVendor" aria-describedby="searchVendor" placeholder="Cari nama vendor"> -->
                        <div class="input-group">
                            <input type="text" class="form-control" v-model="searchVendorName" aria-label="searchVendor" aria-describedby="searchVendor" placeholder="Vendor Name">
                        </div>
                    </div>
                     <div class="col-2">
                        <button class="btn btn-primary btn-sm" style=" border-radius: 10px; width : 100%; height : 35.33px;" @click="searchData()">
                            Cari
                        </button>
                    </div>
              </div>
              <div v-if="loadingTable == false && totalData == 0" style="display: flex; justify-content : center; align-items: center;">
                <div>
                  <img class="text-center" src="~@/assets/images/no_vendor.png" style="padding-top:20%;" />
                  <div class="text-center mt-3" style="font-weight : 800; font-size: 20px; line-height : 20px;">Belum ada vendor terdaftar</div>
                  <div class="text-center mt-3" style="font-size: 16px; line-height : 20px;">Silahkan tambahkan vendor</div>
                </div>
              </div>
              <div v-else>
                <table class="table table-sm table-bordered table-striped table-responsive-sm mt-2">
                  <thead class="">
                    <tr>
                      <th class="text-center">Vendor Name</th>
                      <th class="text-center">Masa Polis Utama</th>
                      <th class="text-center">Default Rate</th>
                      <th class="text-center">Year</th>
                      <th class="text-center" colspan="2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="loadingTable == true">
                      <td colspan="9" class="text-center"><img src="~@/assets/images/load-button.gif" /></td>
                    </tr>
                    <tr v-else-if="loadingTable == false && totalData == 0">
                      <td colspan="9" class="text-center">Data not available</td>
                    </tr>
                    <tr v-for="data in dataVendor" :key="data.orderDetailsId" v-else :class="data.active ? `` : 'table-secondary'">          
                      <td :style="data.active ? '' : 'color:rgba(76, 81, 86, 0.3);'">
                        {{data.partnerName}}
                      </td>
                      <td class="text-center" :style="data.active ? '' : 'color:rgba(76, 81, 86, 0.3);'">
                         <span
                            class="item-badge"
                            :style="`background-color: ${data.active ? '#EAF5FE;' : 'rgba(76, 81, 86, 0.1);'}  color : ${ data.active ?  '' : 'rgba(76, 81, 86, 0.3)'};`"
                          >
                            Start: {{data.polisStartDate}}
                          </span>
                          <span
                            class="item-badge"
                            :style="`background-color: ${data.active ? '#FEF4EA;' : 'rgba(76, 81, 86, 0.1)'} color : ${ data.active ?  '' : 'rgba(76, 81, 86, 0.3)'};`"
                          >
                            End: {{data.polisEndDate}}
                          </span>
                      </td>
                      <td class="text-center" :style="`${data.active ? '' : 'color:rgba(76, 81, 86, 0.3);'}`">
                        {{data.rate}}
                      </td>
                      <td class="text-center" :style="`${data.active ? '' : 'color:rgba(76, 81, 86, 0.3);'}`">
                        {{data.year ? data. year : '-'}}
                      </td>
                      <td class="text-center">
                        <button 
                          :class="data.active ? `btn btn-sm btn-outline-primary btn-edit` : `btn btn-sm btn-outline-secondary`" 
                          @click="toRegisterVendorPage(true, data.id)" 
                          :disabled="!data.active"
                          :data-toggle="data.active ? 'tooltip' : ''" 
                          data-placement="bottom" 
                          title="Edit data vendor"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none" >
                            <path d="M6.92221 12.1386L6.39188 11.6083L6.92221 12.1386L11.5305 7.53033C11.5492 7.51166 11.568 7.49293 11.5869 7.47412C11.8006 7.26148 12.0242 7.03899 12.154 6.77703L11.482 6.44402L12.154 6.77703C12.3966 6.28742 12.3966 5.71258 12.154 5.22297L11.482 5.55598L12.154 5.22297C12.0242 4.96101 11.8006 4.73852 11.5869 4.52588C11.568 4.50707 11.5492 4.48834 11.5305 4.46967L11.0002 5L11.5305 4.46967C11.5118 4.451 11.4931 4.43218 11.4743 4.41328C11.2616 4.19958 11.0392 3.97599 10.7772 3.84618C10.2876 3.60356 9.71274 3.60356 9.22314 3.84618C8.96117 3.97599 8.73868 4.19958 8.52604 4.41328C8.50723 4.43218 8.4885 4.451 8.46983 4.46967L3.86155 9.07796C3.84899 9.09052 3.83631 9.10314 3.82356 9.11584C3.6673 9.27148 3.49929 9.43882 3.38028 9.64903C3.26126 9.85923 3.20421 10.0894 3.15114 10.3035C3.14681 10.3209 3.14251 10.3383 3.1382 10.3555L2.808 11.6763C2.80539 11.6868 2.80271 11.6974 2.79999 11.7083C2.76216 11.8591 2.71579 12.0439 2.70014 12.2039C2.68247 12.3846 2.68089 12.7411 2.96998 13.0302C3.25908 13.3193 3.61558 13.3177 3.7963 13.3C3.95625 13.2844 4.1411 13.238 4.2919 13.2002C4.30273 13.1974 4.31339 13.1948 4.32385 13.1922L5.64464 12.862C5.66187 12.8577 5.67924 12.8534 5.69671 12.849C5.91077 12.796 6.14093 12.7389 6.35114 12.6199C6.56134 12.5009 6.72868 12.3329 6.88431 12.1766C6.89702 12.1639 6.90964 12.1512 6.92221 12.1386Z" :stroke="data.active ? '#1C68D9' : '#C1C2C4'" stroke-width="1.5"/>
                            <path d="M8.3335 5.00002L10.3335 3.66669L12.3335 5.66669L11.0002 7.66669L8.3335 5.00002Z" :fill="data.active ? '#1C68D9' : '#C1C2C4'"/>
                          </svg>
                        </button>
                      </td>
                      <td class="text-center">
                        <div class="custom-controls-stacked d-block">
                            <label :class="data.active ? 'custom-control material-switch switch-on' : 'custom-control material-switch switch-off'">
                              <input 
                                type="checkbox" 
                                :id="`customSwitch-${data.orderDetailsId}`" 
                                class="material-switch-control-input" 
                                :checked="data.active" @change="handleVendorSwitch(data)" 
                              >
                              <span class="material-switch-control-indicator"
                                data-toggle="tooltip"
                                data-placement="bottom" 
                                :title="data.active ? 'Disable vendor' : 'Enable vendor'"
                              >
                              </span>
                            </label>
                        </div>
                        
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1" style="display: inline-flex;">
                    <div style="margin-right: 10px;">
                      <select class="form-control form-control-sm" v-model="itemPerPage" @change="searchData()">
                        <option value="10">10</option>
                        <option value="40">40</option>
                        <option value="80">80</option>
                      </select>
                    </div>
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }}
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1">
                          <li>
                            {{'<'}}</li> </a> <a class="page">
                          <li>{{ currentPage }} of {{ totalPage }} page</li>
                        </a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage">
                          <li>></li>
                        </a>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              ​
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /#page-content-wrapper -->
    <!-- MODAL PART -->
    <div class="modal fade" id="modalTest" role="dialog" data-backdrop="static" data-keyboard="false"></div>
    <div class="modal fade" id="modalDisableVendor" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered modal-lg" style="width : 650px;" >
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Disable Reason</h4>
            </div>
          </div>
          <div class="modal-body">
            <div class="container">
              <div class="row">
                <div class="col-6">
                  <div class="mb-2" style="font-size: 14px; line-height: 17px;">Nama Vendor</div>
                  <span style="font-weight : 600; font-size: 16px; line-height: 24px;">{{currentEditedVendor.partnerName}}</span>
                </div>
                <div class="col-6">
                  <div class="mb-2" style="font-size: 14px; line-height: 17px;">Masa Polis Utama</div>
                  <div style="display : flex; justify-content : space-between">
                    <span
                      class="item-badge"
                      :style="'background-color: rgba(48, 152, 247, 0.1);'"
                    >
                      Start : {{currentEditedVendor.polisStartDate}}
                    </span>
                    <span
                      class="item-badge"
                      :style="'background-color: rgba(247, 143, 48, 0.1);'"
                    >
                      End : {{currentEditedVendor.polisEndDate}}
                    </span>
                  </div> 
                </div>
              </div>
              <div class="mt-4">
                <textarea class="form-control" :class="{ 'form-control border-red' : $v.disableReason.$error}" rows="3" placeholder="Berikan penjelasan anda" v-model.trim="$v.disableReason.$model"></textarea>
                <div  style="float : right;">{{disableReason.length}}/{{maxDisableReasonLength}}</div>
                <div style="color : red; font-size : 12px;" v-if="$v.disableReason.$error && !$v.disableReason.required">Disable reason is required.</div>
                <div style="color : red; font-size : 12px;" v-if="$v.disableReason.$error && !$v.disableReason.minLength">Disable reason must have at least {{$v.disableReason.$params.minLength.min}} letters.</div>
                <div style="color : red; font-size : 12px;" v-if="$v.disableReason.$error && !$v.disableReason.maxLength">Disable reason must have less than {{$v.disableReason.$params.maxLength.max}} letters.</div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-danger" @click="closeDisableVendorModal">Batal</button>
            <button class="btn btn-sm btn-primary" @click="validateReason(currentEditedVendor)">Simpan</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { required, minLength,maxLength } from 'vuelidate/lib/validators'
import Swal from 'sweetalert2';
import SideBar from "../SideBar";
import { Money } from "v-money";
export default {
  name: "insuranceVendorListPage",
  components: {
    SideBar,
    Multiselect,
    Money,
  },
  data() {
    return {
      loadingTable: false,
      selectedVendor : [],
      currentEditedVendor : {},
      disableReason : '',
      maxDisableReasonLength : 144,
      admin: "",
      permission: [],
      totalPage: 0,
      totalData: 0,
      currentPage: 1,
      itemPerPage: 10,
      searchVendorName: "",
      dataVendor: [],
      loadingButtonSave: false,
      token: localStorage.getItem("jwt"),
      password: "",
      disableSave: false,
      cancelInsurancePermission: false,
    };
  },
  validations: {
    disableReason : {
      required,
      minLength: minLength(5),
      maxLength: maxLength(144),
    }
  },
  methods: {
    cekPermission() {
      this.permission = localStorage.getItem('roles').replace(/"/g, "").replace("[", "").replace("]", "").split(",")
      for (var i = 0; i < this.permission.length; i++) {
        if(['22','22.1', '22.2', '22.3'].includes(this.permission[i])) {
          this.viewNewInsurance = true
        }
        if(this.permission[i] == '22.1') {
          this.viewNewInsuranceVendor = true
        }
        if(this.permission[i] == '22.2') {
          this.viewNewInsurancePendingDeclare = true
        }
        if(this.permission[i] == '22.3') {
          this.viewNewInsuranceBatch = true
        }

        if (this.viewNewInsuranceVendor == false) {
          this.$router.push('/')
        }
      }
    },
    toRegisterVendorPage(isEdit, vendorId){
      if(isEdit && vendorId) {
        this.$router.push({
          path:'/insurance/vendors/register',
          query : {
            edit : true,
            vendorId : vendorId,
          }
        })
      } else {
        // window.open(
        this.$router.push({path:'/insurance/vendors/register'})
        // )
      }
      
    },
    handleVendorSwitch(vendor) {
      vendor.active = vendor.active ? false : true
      this.currentEditedVendor = vendor
      this.dataVendor = [...this.dataVendor]
      if(!vendor.active) {
        $("#modalDisableVendor").modal("show");
      } else {
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-primary ml-2",
            cancelButton: "btn btn-danger"
          },
          buttonsStyling: false
        });
        swalWithBootstrapButtons.fire({
          title: "<strong style='font-size : 24px; font-weight : 600;'>Apakah kamu yakin ingin menampilkan kembali vendor ini ?</strong>",
          icon: "warning",
          width: '32rem',
          html: `
            <div class="card col-12 mt-3" style="max-width : 100%">
              <div class="card-body">
                <span class="mb-2" style="line-height : 17px; font-size : 14px; float: left;">Disable reason</span>
                <input class="form-control" type="text" value="${vendor.deactivateReason}" disabled/>
              </div>
            </div>
          `,
          reverseButtons: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonText: `
            Ya, saya yakin!
          `,
          cancelButtonText: `
            Batalkan
          `,
        }).then((result) => {
         
          if(result.isConfirmed) {
            this.changeVendorStatus(vendor)
          } else {  
            this.closeDisableVendorModal()
          }
        });     
      }
       
    },
    closeDisableVendorModal() {
      let vendor = this.dataVendor.find(data => data.id == this.currentEditedVendor.id)

      vendor.active = !vendor.active;
      this.dataVendor = [...this.dataVendor]
      this.currentEditedVendor = {};
      this.disableReason='';
      $("#modalDisableVendor").modal("hide");
      this.$v.$reset()
    },
    validateReason(vendor) {
      this.$v.$touch()
      if(this.$v.$invalid || this.$v.disableReason.$error){

      } else {
        this.changeVendorStatus(vendor)
      }
    },
    changeVendorStatus(vendor) {
      // hit api  
      const ini = this
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false
      });

      this.$http
        .post(
          `${process.env.CHANGE_VENDOR_STATUS}/${vendor.id}/activated`, {
           isActive : vendor.active ? 1 : 0,
           reasonDisable : this.disableReason
          }, {
            timeout : 300 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          if(response.status == 200 && response.data.status == 200) {
            swalWithBootstrapButtons.fire({
              icon: "success",
              title: "Success",
              text: "Berhasil mengubah status vendor",
            }).then((result) => {
              if(result.isConfirmed) {
                $("#modalDisableVendor").modal("hide");
                this.disableReason = "";
                this.getData()
                this.$router.push({
                  path: "/insurance/vendors",
                  query: {
                    vendorName: '',
                    page: 1,
                    itemPerPage: 10,
                  },
                });
              } 
            });
          } else {
             swalWithBootstrapButtons.fire({
              icon: "error",
              title: "Failed",
              text: response.data.message,
            }).then((result) => {
              if(result.isConfirmed) {
                $("#modalDisableVendor").modal("hide");
                this.disableReason = "";
                this.$router.push({
                  path: "/insurance/vendors",
                  query: {
                    vendorName: '',
                    page: 1,
                    itemPerPage: 10,
                  },
                });
              } 
            });
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
              icon: "error",
              title: "Failed",
              text: error,
            }).then((result) => {
              if(result.isConfirmed) {
                if(error.response.data.status == 401) {
                  this.handleLogout()
                } else {
                  $("#modalDisableVendor").modal("hide");
                  ini.getData()
                  ini.disableReason = "";
                }
              } 
            });
        });
   
    },
    sendLog(w, x) {
      // var today = new Date();
      // var month = today.getMonth()+1
      // if (month < 10) {
      //     month = '0'+month
      // }
      // var dateDay = today.getDate()
      // if (dateDay < 10) {
      //     dateDay = '0'+dateDay
      // }
      // var hours = today.getHours()
      // if (hours < 10) {
      //     hours = '0'+hours
      // }
      // var minutes = today.getMinutes()
      // if (minutes < 10) {
      //     minutes = '0'+minutes
      // }
      // var second = today.getSeconds()
      // if (second < 10) {
      //     second = '0'+second
      // }
      // var date = today.getFullYear()+'-'+month+'-'+dateDay;
      // var time = hours + ":" + minutes + ":" + second;
      // var dateTime = date+' '+time;
      // var admin = this.admin
      // var command = 'add-logs'
      // // var productName = this.productNameChoose
      // this.$http.post(process.env.LOG_URL+"/company/"+x,{
      //     codeLogs: w,
      //     params: [],
      // },{
      //     headers: {'Asani-Token':localStorage.getItem('jwt')}
      // })
      // .then(response => {
      // })
      // .catch(error => {
      //     console.log(error)
      // })
    },
    searchData() {
      this.$router.push({
        path: "/insurance/vendors",
        query: {
          vendorName: this.searchVendorName,
          page: 1,
          itemPerPage: this.itemPerPage,
        },
      });
      location.reload();
      this.getData();
    },
    toDataPage(pagePost) {
      this.$router.push({
        path: "/insurance/vendors",
        query: {
          vendorName: this.searchVendorName,
          page: pagePost,
          itemPerPage: this.itemPerPage,
        },
      });
      location.reload();
      this.getData();
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    getData() {
      this.loadingTable = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      this.searchVendorName = this.$route.query.vendorName;
      this.currentPage = parseInt(this.$route.query.page);
      this.itemPerPage = parseInt(this.$route.query.itemPerPage);
      this.$http
        .post(
          process.env.GET_VENDOR_LIST, {
            keyword: this.searchVendorName,
            page: this.currentPage,
            itemPerPage: this.itemPerPage,
          }, {
            timeout : 300 * 1000,
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
        if(response.status == 200 || response.data.status == 200) {
          this.dataVendor = response.data.data.data;
          this.totalPage = response.data.data.totalPage;
          this.totalData = response.data.data.totalData;
          this.currentPage = response.data.data.currentPage;
        } else {
          swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${response.data.message}`,
              icon: "error"
          }).then(result => {
            if(result.isConfirmed) {
                  
            }
          })
        }

        this.loadingTable = false;
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
              title: "Failed",
              text: `${error}`,
              icon: "error"
          }).then(result => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        });
    },

    dateFormat($date) {
      const d = new Date($date)
      if (d.getDate().toString().length == 1) {
        var date = '0' + d.getDate().toString()
      } else {
        date = d.getDate()
      }
      if ((d.getMonth() + 1).toString().length == 1) {
        var month = '0' + (d.getMonth() + 1).toString()
      } else(
        month = (d.getMonth() + 1)
      )
      return date + '-' + month + '-' + d.getFullYear()
    },
  },
  created() {
    const allPermission = JSON.parse(localStorage.getItem('roles'))
    this.cancelInsurancePermission = allPermission && allPermission.indexOf('15.2') >= 0
    this.getData();
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
  },
  watch: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
/* switch */
.custom-control.material-switch.switch-on {
  /* --color: rgba(255, 52, 68, 1); */
  --color : rgba(48, 152, 247, 1);
  --background : #B0D8FC;
  padding-left: 0;
}

.custom-control.material-switch.switch-off {
  --color: rgba(255, 52, 68, 1);
  /* --color : rgba(48, 152, 247, 1); */
  --background : #FFB2B8;
  padding-left: 0;
}

.custom-control.material-switch .material-switch-control-input {
  display: none;
}

.custom-control.material-switch .material-switch-control-input:checked~.material-switch-control-indicator::after {
  background-color: var(--color);
  left: 17px;
}

.custom-control.material-switch .material-switch-control-indicator {
  display: inline-block;
  position: relative;
  top: 4px;
  width: 32px;
  height: 11px;
  background: var(--background);
  border-radius: 16px;
  transition: 0.3s;
}

.custom-control.material-switch .material-switch-control-indicator::after {
  content: '';
  display: block;
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  transition: 0.3s;
  top: -2.5px;
  left: -1px;
  /* background: #fdfdfd; */
  background: var(--color);;
  box-shadow: 0 2px 10px #aaa;
}

.btn-outline-primary{
   border-radius: 0.6rem;
}

.btn-outline-secondary{
   border-radius: 0.6rem;
}

.btn-edit:hover {
  background-color: rgba(214, 234, 253, 1);
}
.item-badge {
  display: inline-block;
  padding: 0.25em 0.7em;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 1rem;
  transition: color 0.15s;
  margin-right: 2px;
}
.total-data {
  margin-top: 7px;
}

#wrapperr {
  overflow: auto;
  margin: 5px 3px;
}

#c1 {
  float: left;
}

#c2 {
  float: right;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797FB;
  /*margin: auto 5px;*/
  color: #fff;
  /*font-weight: bold;*/
  border: 1px solid #2797FB;
}

.p8 a:hover {
  text-decoration: none;
}

.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797FB;
}

.alignleft {
  float: left;
}

.alignright {
  float: right;
}

.one-line {
  display: flex;
  margin: 5px 0px;
}

.border-red {
  border-color: red;
}

.one-line .ol-label.storage {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label {
  width: 188px;
  margin: 2px 0px;
}

.one-line .ol-label-roles {
  width: 130px;
  margin: 2px 0px;
}

.one-line .ol-label-price {
  width: 263px;
  margin: 2px 0px;
}

.one-line .ol-titik2 {
  width: 15px;
  margin: 2px 0px;
}

.stPrice-sch {
  width: 186px;
  margin: 7px 0px;
}

.delivery-titik2 {
  margin: 7px 0px;
  padding-right: 7px;
}

.input-group-addon {
  padding: 7px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #555;
  text-align: center;
  background-color: #eee;
  border: 1px solid #ccc;
  border-radius: 4px 0px 0px 4px;
  border-right: none;
  margin: 0px 0px 0px 0px;
  height: fit-content;
}

.label-addon-rp {
  margin: 5px 0px;
}

.modal-lg,
.modal-xl {
  max-width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/VendorPage.vue